(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tjr-curated-finds"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tjr-cf').forEach((root) => {
    if (root._tjrCfInit) return;
    root._tjrCfInit = true;

    const slides = Array.from(root.querySelectorAll('[data-cf-slide]'));
    if (!slides.length) return;

    // Grid layout shows every product at once, so we must NOT hide/disable the
    // non-active cards the way the crossfade carousel does — only move the
    // highlight (border + matching hotspot).
    const isGrid = root.classList.contains('tjr-cf--grid');

    let ci = 0;
    const productState = slides.map(() => 0);

    const setProductTabindex = (product, on) => {
      product.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', on ? '0' : '-1'));
    };

    const renderProduct = () => {
      const slide = slides[ci];
      const pi = productState[ci];
      slide.querySelectorAll('[data-cf-product]').forEach((el, i) => {
        const on = i === pi;
        el.classList.toggle('is-active', on);
        if (isGrid) {
          el.removeAttribute('aria-hidden');
          setProductTabindex(el, true);
        } else {
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
          setProductTabindex(el, on);
        }
      });
      slide.querySelectorAll('[data-cf-dot]').forEach((el, i) => {
        const on = i === pi;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
      });
      slide.querySelectorAll('[data-cf-hotspot]').forEach((el, i) => {
        const on = i === pi;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };

    const renderSlide = () => {
      slides.forEach((s, i) => {
        const on = i === ci;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        // Keep focus out of hidden slides; the active slide is re-enabled by renderProduct().
        if (!on) {
          s.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        } else {
          s.querySelectorAll('[data-cf-dot], [data-cf-hotspot]').forEach((el) => el.removeAttribute('tabindex'));
        }
      });
      renderProduct();
    };

    const go = (delta) => {
      ci = (ci + delta + slides.length) % slides.length;
      renderSlide();
    };

    const prev = root.querySelector('[data-cf-prev]');
    const next = root.querySelector('[data-cf-next]');
    prev && prev.addEventListener('click', () => go(-1));
    next && next.addEventListener('click', () => go(1));

    slides.forEach((slide, si) => {
      const select = (i) => { productState[si] = i; if (si === ci) renderProduct(); };
      slide.querySelectorAll('[data-cf-dot]').forEach((el, i) => el.addEventListener('click', () => select(i)));
      slide.querySelectorAll('[data-cf-hotspot]').forEach((el, i) => el.addEventListener('click', () => select(i)));
    });

    // Theme editor: jump to the slide/product the merchant is editing.
    document.addEventListener('shopify:block:select', (e) => {
      const idx = slides.indexOf(e.target.closest('[data-cf-slide]'));
      if (idx > -1) { ci = idx; renderSlide(); }
    });

    renderSlide();
  });


  document.querySelector('[data-cf-prev-mobile]')?.addEventListener('click', () => {
    document.querySelector('[data-cf-prev]')?.click();
  });

document.querySelector('[data-cf-next-mobile]')?.addEventListener('click', () => {
  document.querySelector('[data-cf-next]')?.click();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-designer-filter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initFilter(root) {
      if (!root || root._tjrDfInit) return;
      root._tjrDfInit = true;

      var letters = Array.prototype.slice.call(root.querySelectorAll('[data-df-letter]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-df-group]'));
      if (!letters.length || !groups.length) return;

      var isFilter = root.dataset.mode === 'filter';

      function setActive(letter) {
        letters.forEach(function (el) {
          var on = el.getAttribute('data-df-letter') === letter;
          el.classList.toggle('is-active', on);
          if (on) el.setAttribute('aria-current', 'true');
          else el.removeAttribute('aria-current');
        });
      }

      // Distance to leave above a jumped-to heading, so it clears the theme's
      // sticky header. Comes from the "Scroll offset" setting.
      function anchorOffset() {
        var raw = getComputedStyle(root).getPropertyValue('--tjr-df-anchor-offset');
        return parseInt(raw, 10) || 0;
      }

      // Resolved by letter rather than by id: the group is the authority on
      // where "M" lives, so scrolling can't break if an id/href ever drift.
      function groupFor(letter) {
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].getAttribute('data-df-group') === letter) return groups[i];
        }
        return null;
      }

      if (isFilter) {
        letters.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var letter = btn.getAttribute('data-df-letter');
            var clearing = btn.classList.contains('is-active');
            groups.forEach(function (group) {
              group.hidden = clearing ? false : group.getAttribute('data-df-group') !== letter;
            });
            setActive(clearing ? null : letter);
          });
        });
        return;
      }

      // ── Jump mode: smooth scroll + underline follows the scroll position ──
      // Explicit scroll math rather than scrollIntoView: it lets the offset
      // clear the theme's sticky header, and the href stays a real anchor so
      // the browser still jumps natively if this handler never runs.
      letters.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var letter = link.getAttribute('data-df-letter');
          var target = groupFor(letter);
          if (!target) {
            var id = (link.getAttribute('href') || '').slice(1);
            target = id && document.getElementById(id);
          }
          if (!target) return; // leave the native anchor jump alone

          event.preventDefault();
          var top = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - anchorOffset();
          window.scrollTo({ top: Math.max(0, top), behavior: REDUCED.matches ? 'auto' : 'smooth' });
          if (window.history && window.history.replaceState && target.id) {
            window.history.replaceState(null, '', '#' + target.id);
          }
          setActive(letter);
        });
      });

      var ticking = false;
      function spy() {
        ticking = false;
        var offset = anchorOffset() + 4;
        var active = groups[0];
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].getBoundingClientRect().top <= offset) active = groups[i];
          else break;
        }
        if (active) setActive(active.getAttribute('data-df-group'));
      }

      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(spy);
        },
        { passive: true }
      );

      spy();
    }

    function initAll() {
      document.querySelectorAll('[data-tjr-df]').forEach(initFilter);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-designer-profile"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tjr-dp [data-tjr-carousel]').forEach((root) => {
    if (root._tjrInit) return;
    root._tjrInit = true;
    const track = root.querySelector('[data-tjr-track]');
    const prev = root.querySelector('[data-tjr-prev]');
    const next = root.querySelector('[data-tjr-next]');
    if (!track) return;

    const step = () => {
      const card = track.querySelector('li');
      const gap = parseFloat(getComputedStyle(track).columnGap || '24') || 24;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    const sync = () => {
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    // Pointer drag-to-scroll (layers on top of native wheel/touch/keyboard scroll).
    let down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
    });
    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId); }
      if (moved) track.scrollLeft = startScroll - dx;
    });
    const end = () => { down = false; track.classList.remove('is-dragging'); };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-designers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initCats(root) {
      if (!root || root._tjrCatsInit) return;
      root._tjrCatsInit = true;

      var stage = root.querySelector('[data-cats-stage]');
      var viewport = root.querySelector('[data-cats-viewport]');
      var dotsWrap = root.querySelector('[data-cats-dots]');
      var prev = root.querySelector('[data-cats-prev]');
      var next = root.querySelector('[data-cats-next]');
      if (!stage || !viewport) return;

      var behavior = function () {
        return REDUCED.matches ? 'auto' : 'smooth';
      };
      var maxScroll = function () {
        return viewport.scrollWidth - viewport.clientWidth;
      };

      function sync() {
        var max = maxScroll();
        var left = viewport.scrollLeft;

        if (prev) prev.disabled = left <= 2;
        if (next) next.disabled = left >= max - 2;

        if (!dotsWrap) return;
        var dots = Array.prototype.slice.call(dotsWrap.children);
        if (!dots.length) return;
        var page = max > 0 ? Math.round((left / max) * (dots.length - 1)) : 0;
        dots.forEach(function (dot, i) {
          var on = i === page;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      // One dot per scrolled page — the Figma mock always shows three, but the
      // real count depends on how many tiles the merchant added.
      function buildDots() {
        var scrollable = maxScroll() > 1;
        stage.classList.toggle('is-static', !scrollable);

        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';

        var pages = scrollable ? Math.ceil(viewport.scrollWidth / viewport.clientWidth) : 1;
        if (pages <= 1) {
          dotsWrap.hidden = true;
          return;
        }
        dotsWrap.hidden = false;

        for (var i = 0; i < pages; i++) {
          (function (index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'tjr-cats__dot';
            dot.setAttribute('aria-label', 'Show collections ' + (index + 1) + ' of ' + pages);
            dot.addEventListener('click', function () {
              var target = (maxScroll() / (pages - 1)) * index;
              viewport.scrollTo({ left: target, behavior: behavior() });
            });
            dotsWrap.appendChild(dot);
          })(i);
        }
        sync();
      }

      function page(direction) {
        viewport.scrollBy({ left: direction * viewport.clientWidth, behavior: behavior() });
      }

      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      viewport.addEventListener('scroll', sync, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(buildDots, 150);
      });

      // Images finishing late change scrollWidth — recount then.
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', buildDots, { once: true });
      });

      // Theme editor: bring the tile being edited into view.
      document.addEventListener('shopify:block:select', function (event) {
        if (!root.contains(event.target)) return;
        var item = event.target.closest ? event.target.closest('.tjr-cats__item') : null;
        if (item) item.scrollIntoView({ behavior: behavior(), inline: 'center', block: 'nearest' });
      });

      buildDots();
    }

    function initAll() {
      document.querySelectorAll('[data-tjr-cats]').forEach(initCats);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-guide"] && !Shopify.designMode) return;
  try {
    
  // Phone carousel arrows for the related-guides track. On desktop the arrows are display:none
  // and the track is a grid with no overflow, so scrollBy would be a harmless no-op anyway.
  document.querySelectorAll('.tjr-guide').forEach((root) => {
    if (root._tjrGuideRelatedInit) return;
    root._tjrGuideRelatedInit = true;
    const track = root.querySelector('[data-tjr-guides-track]');
    const prev = root.querySelector('[data-tjr-guides-prev]');
    const next = root.querySelector('[data-tjr-guides-next]');
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.tjr-guide__scard');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });


  // FAQ accordion — smooth open/close on <details>. The wrapper animates 0fr → 1fr;
// JS only sequences the `open` attribute around that transition. Works natively without JS.
document.querySelectorAll('.tjr-guide__faq-item').forEach((item) => {
  if (item._tjrFaqInit) return;
  item._tjrFaqInit = true;

  const summary = item.querySelector('.tjr-guide__faq-q');
  const wrap = item.querySelector('.tjr-guide__faq-a-wrap');
  if (!summary || !wrap) return;

  let onEnd = null;
  const clearEnd = () => {
    if (onEnd) { wrap.removeEventListener('transitionend', onEnd); onEnd = null; }
  };
  const hasTransition = () => parseFloat(getComputedStyle(wrap).transitionDuration) > 0;

  summary.addEventListener('click', (e) => {
    e.preventDefault();
    const closing = item.classList.contains('is-closing');

    if (item.open && !closing) {
      // CLOSE: animate to 0fr, then drop `open` once the row transition ends.
      item.classList.add('is-closing');
      if (!hasTransition()) {
        item.open = false;
        item.classList.remove('is-closing');
        return;
      }
      onEnd = (ev) => {
        if (ev.target !== wrap || ev.propertyName !== 'grid-template-rows') return;
        clearEnd();
        item.open = false;
        item.classList.remove('is-closing');
      };
      wrap.addEventListener('transitionend', onEnd);
    } else {
      // OPEN (or reverse a close in progress): set `open` while still at 0fr,
      // then release on the next frame so 0fr → 1fr transitions every time.
      clearEnd();
      item.classList.add('is-closing');
      item.open = true;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => item.classList.remove('is-closing'));
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-hero"] && !Shopify.designMode) return;
  try {
    
  // Background videos must be muted to autoplay; some browsers (and the theme
  // editor) ignore the markup attribute, so force it here and nudge play().
  document.querySelectorAll('[data-tjr-hero-video]').forEach((video) => {
    if (video._tjrHeroInit) return;
    video._tjrHeroInit = true;

    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');

    const tryPlay = () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    };

    if (video.readyState >= 2) tryPlay();
    video.addEventListener('loadeddata', tryPlay, { once: true });
    video.addEventListener('canplay', tryPlay, { once: true });

    const onInteract = () => {
      tryPlay();
      document.removeEventListener('click', onInteract);
      document.removeEventListener('touchstart', onInteract);
      document.removeEventListener('scroll', onInteract);
    };
    document.addEventListener('click', onInteract, { passive: true });
    document.addEventListener('touchstart', onInteract, { passive: true });
    document.addEventListener('scroll', onInteract, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && video.paused) tryPlay();
    });
  });

  // Collection-slider layout: arrows, dots, drag + keyboard scrolling.
  document.querySelectorAll('[data-tjr-cs]').forEach((root) => {
    if (root._tjrCsInit) return;
    root._tjrCsInit = true;

    const track = root.querySelector('[data-tjr-cs-track]');
    const prev = root.querySelector('[data-tjr-cs-prev]');
    const next = root.querySelector('[data-tjr-cs-next]');
    const dotsWrap = root.parentElement.querySelector('[data-tjr-cs-dots]');
    if (!track) return;

    const page = () => track.clientWidth * 0.9;

    let down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
    });
    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId); }
      if (moved) track.scrollLeft = startScroll - dx;
    });
    const end = () => { down = false; track.classList.remove('is-dragging'); };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    prev && prev.addEventListener('click', () => track.scrollBy({ left: -page(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: page(), behavior: 'smooth' }));

    let dots = [];
    const pages = () => Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth - 0.05));
    const buildDots = () => {
      if (!dotsWrap) return;
      const n = pages();
      dotsWrap.innerHTML = '';
      dots = [];
      if (n <= 1) return;
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'tjr-cslider__dot';
        b.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        b.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }));
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    };
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      // Everything fits (few cards, or a wide viewport) → there is no carousel to drive,
      // so the arrows and dots come out rather than sitting there permanently dead.
      const scrollable = max > 2;
      root.classList.toggle('is-static', !scrollable);
      if (prev) { prev.hidden = !scrollable; prev.disabled = track.scrollLeft <= 2; }
      if (next) { next.hidden = !scrollable; next.disabled = track.scrollLeft >= max - 2; }
      if (dotsWrap) dotsWrap.hidden = dots.length === 0;
      if (dots.length) {
        const active = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === Math.min(active, dots.length - 1)));
      }
    };

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: page(), behavior: 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -page(), behavior: 'smooth' }); }
    });

    track.addEventListener('scroll', () => { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', () => { buildDots(); sync(); });
    // Cards are flex-sized, so overflow can change without a window resize (theme editor
    // re-render, late fonts, container width changes). Re-measure from the track itself.
    if (window.ResizeObserver) {
      new ResizeObserver(() => { buildDots(); sync(); }).observe(track);
    }
    buildDots();
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-media-feature"] && !Shopify.designMode) return;
  try {
    
  class TjrMediaPlayer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.playBtn = this.querySelector('[data-tjr-play]');
      this.player = this.querySelector('[data-tjr-player]');
      this.template = this.querySelector('[data-tjr-video-template]');
      if (this.playBtn) {
        this.playBtn.addEventListener('click', () => this.play());
      }
    }

    play() {
      if (!this.player || this.hasAttribute('data-playing')) return;

      if (this.template) {
        this.player.appendChild(this.template.content.cloneNode(true));
        const video = this.player.querySelector('video');
        if (video) {
          video.play().catch(() => {});
        }
      } else {
        const type = this.dataset.externalType;
        const id = this.dataset.externalId;
        if (!type || !id) return;
        const iframe = document.createElement('iframe');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Video');
        if (type === 'youtube') {
          iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        } else if (type === 'vimeo') {
          iframe.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
        }
        this.player.appendChild(iframe);
      }

      this.player.hidden = false;
      this.setAttribute('data-playing', '');
    }
  }

  if (!customElements.get('tjr-media-player')) {
    customElements.define('tjr-media-player', TjrMediaPlayer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-product-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // One card + gap = one "page" of scroll.
    function step(track) {
      var c = track.querySelector('li');
      var g = parseFloat(getComputedStyle(track).columnGap || '24') || 24;
      return c ? c.getBoundingClientRect().width + g : track.clientWidth * 0.8;
    }

    // Update the arrows' *visual* disabled state (aria-disabled) from scroll pos.
    // `max <= 2` means the cards don't overflow, so both ends are "disabled".
    function sync(root) {
      var track = root.querySelector('[data-tjr-track]');
      if (!track) return;
      var prev = root.querySelector('[data-tjr-prev]');
      var next = root.querySelector('[data-tjr-next]');
      var max = track.scrollWidth - track.clientWidth;
      var overflows = max > 2;
      if (prev) prev.setAttribute('aria-disabled', (!overflows || track.scrollLeft <= 2) ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', (!overflows || track.scrollLeft >= max - 2) ? 'true' : 'false');
    }

    function setup(root) {
      if (root._tjrInit) return; root._tjrInit = true;
      var track = root.querySelector('[data-tjr-track]');
      if (!track) return;
      var onScroll = function () { window.requestAnimationFrame(function () { sync(root); }); };
      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { sync(root); });
      window.addEventListener('load', function () { sync(root); });
      // Measure after layout/paint so scrollWidth is final.
      window.requestAnimationFrame(function () { sync(root); });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.tjr-pf').forEach(setup);
    }

    // Clicks via delegation on document: they always fire regardless of when the
    // markup was rendered (page load, theme-editor re-render) and are never
    // blocked by disabled state. scrollBy is clamped by the browser at each edge,
    // so this can't over-scroll past the ends.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-tjr-prev], [data-tjr-next]');
      if (!btn) return;
      var root = btn.closest('.tjr-pf');
      var track = root && root.querySelector('[data-tjr-track]');
      if (!track) return;
      var dir = btn.hasAttribute('data-tjr-prev') ? -1 : 1;
      track.scrollBy({ left: dir * step(track), behavior: 'smooth' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    // Theme editor: re-init disabled-state syncing when a section (re)loads.
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-related-collections"] && !Shopify.designMode) return;
  try {
    
  // Rail controls, ported from sections/tjr-designers.liquid so both carousels behave
  // identically: arrows page by a viewport width, dots are built one per scrolled page,
  // and a rail that already fits drops its controls entirely (.is-static).
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initRail(root) {
      if (!root || root._tjrRelColInit) return;
      root._tjrRelColInit = true;

      var stage = root.querySelector('[data-rc-stage]');
      var viewport = root.querySelector('[data-rc-viewport]');
      var dotsWrap = root.querySelector('[data-rc-dots]');
      var prev = root.querySelector('[data-rc-prev]');
      var next = root.querySelector('[data-rc-next]');
      if (!stage || !viewport) return;

      var behavior = function () {
        return REDUCED.matches ? 'auto' : 'smooth';
      };
      var maxScroll = function () {
        return viewport.scrollWidth - viewport.clientWidth;
      };

      function sync() {
        var max = maxScroll();
        var left = viewport.scrollLeft;

        if (prev) prev.disabled = left <= 2;
        if (next) next.disabled = left >= max - 2;

        if (!dotsWrap) return;
        var dots = Array.prototype.slice.call(dotsWrap.children);
        if (!dots.length) return;
        var page = max > 0 ? Math.round((left / max) * (dots.length - 1)) : 0;
        dots.forEach(function (dot, i) {
          var on = i === page;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function buildDots() {
        var scrollable = maxScroll() > 1;
        stage.classList.toggle('is-static', !scrollable);

        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';

        var pages = scrollable ? Math.ceil(viewport.scrollWidth / viewport.clientWidth) : 1;
        if (pages <= 1) {
          dotsWrap.hidden = true;
          return;
        }
        dotsWrap.hidden = false;

        for (var i = 0; i < pages; i++) {
          (function (index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'tjr-related-collections__dot';
            dot.setAttribute('aria-label', 'Show collections ' + (index + 1) + ' of ' + pages);
            dot.addEventListener('click', function () {
              viewport.scrollTo({ left: (maxScroll() / (pages - 1)) * index, behavior: behavior() });
            });
            dotsWrap.appendChild(dot);
          })(i);
        }
        sync();
      }

      function page(direction) {
        viewport.scrollBy({ left: direction * viewport.clientWidth, behavior: behavior() });
      }

      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      viewport.addEventListener('scroll', sync, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(buildDots, 150);
      });

      // Images finishing late change scrollWidth — recount then.
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', buildDots, { once: true });
      });

      buildDots();
    }

    function initAll() {
      document.querySelectorAll('[data-tjr-rc]').forEach(initRail);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-stories"] && !Shopify.designMode) return;
  try {
    
  // Mobile carousel arrows. On desktop the arrows are hidden and the list is a
  // grid, so scrollBy is a harmless no-op there.
  document.querySelectorAll('.tjr-stories').forEach((root) => {
    if (root._tjrStoriesInit) return;
    root._tjrStoriesInit = true;
    const track = root.querySelector('[data-tjr-stories-track]');
    const prev = root.querySelector('[data-tjr-stories-prev]');
    const next = root.querySelector('[data-tjr-stories-next]');
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.tjr-story');
      const gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjr-story-index"] && !Shopify.designMode) return;
  try {
    
  // Client-side type filtering + "Load more". Liquid can't read the ?type=
  // param, so every published entry is rendered and this:
  //   - filters cards by the active type and keeps the URL (?type=) in sync
  //     (shareable / bookmarkable) via history.pushState / popstate,
  //   - reveals cards a page (items_count) at a time via the Load more button,
  //   - updates the "1 – X of Y" count and page number, hides the button when
  //     the current filter is fully shown, and shows an empty message otherwise.
  // Stories carry data-guide-type="story" (the Story filter value), so they are
  // filtered by exactly the same code path as guide types.
  document.querySelectorAll('[data-tjr-index]').forEach((root) => {
    if (root._tjrIndexInit) return;
    root._tjrIndexInit = true;

    const tabs = Array.from(root.querySelectorAll('[data-tjr-index-tabs] .tjr-story-index__tab-link'));
    const cards = Array.from(root.querySelectorAll('[data-tjr-index-grid] > .tjr-story-index__card'));
    const bar = root.querySelector('[data-tjr-index-bar]');
    const btn = root.querySelector('[data-tjr-index-more]');
    const countEl = root.querySelector('[data-tjr-index-count]');
    const pageEl = root.querySelector('[data-tjr-index-page]');
    const emptyEl = root.querySelector('[data-tjr-index-empty]');
    if (!cards.length) return;

    const pageSize = Math.max(1, parseInt((bar && bar.dataset.pageSize) || '12', 10));
    const ofWord = (bar && bar.dataset.ofWord) || 'of';
    const itemsWord = (bar && bar.dataset.itemsWord) || '';
    const pageWord = (bar && bar.dataset.pageWord) || 'Page';

    const norm = (v) => (v || '').trim().toLowerCase();
    const currentType = () => norm(new URLSearchParams(window.location.search).get('type'));

    let activeType = currentType();
    let shown = pageSize; // how many of the current filter are revealed

    function render() {
      // Show the first `shown` cards that match the active type; hide the rest.
      let matched = 0;
      cards.forEach((card) => {
        const isMatch = !activeType || norm(card.dataset.guideType) === activeType;
        if (!isMatch) { card.hidden = true; return; }
        card.hidden = matched >= shown;
        matched += 1;
      });
      const total = matched;
      const visible = Math.min(shown, total);

      tabs.forEach((tab) => {
        const active = norm(tab.dataset.type) === activeType;
        tab.classList.toggle('is-active', active);
        if (active) tab.setAttribute('aria-current', 'page');
        else tab.removeAttribute('aria-current');
      });

      if (emptyEl) emptyEl.hidden = total !== 0;
      if (bar) bar.hidden = total === 0;
      if (countEl) countEl.textContent = `1 – ${visible} ${ofWord} ${total} ${itemsWord}`.replace(/\s+/g, ' ').trim();
      if (pageEl) pageEl.textContent = `${pageWord} ${Math.max(1, Math.ceil(visible / pageSize))}`;
      if (btn) btn.hidden = visible >= total;
    }

    function setType(type, push) {
      activeType = type;
      shown = pageSize; // reset the reveal when the filter changes
      if (push) {
        const url = new URL(window.location.href);
        if (type) url.searchParams.set('type', type);
        else url.searchParams.delete('type');
        window.history.pushState({ tjrIndexType: type }, '', url.toString());
      }
      render();
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        setType(norm(tab.dataset.type), true);
      });
    });

    if (btn) {
      btn.addEventListener('click', () => {
        shown += pageSize;
        render();
      });
    }

    window.addEventListener('popstate', () => setType(currentType(), false));
    render();
  });

  } catch(e) { console.error(e); }
})();
})();
